import PredictionTableList from "../../components/predictionTablesEditor/predictionTableList";

export default function PredictionTableListPage() {
  return (
    <div style={{ padding: "25px" }}>
      <PredictionTableList />
    </div>
  );
}
